import { Alert, LoadingSpinner, QueryErrorAlert } from '@shared/components';
import type { FundAccountCardState } from '../../../utils/fundAccountCardState';
import type { PairPeriodStatement } from '../../../types/dealerFundStatementPeriod.types';
import {
    NOT_ENTITLED_MESSAGE,
    selectPrompt,
    unavailableMessage,
    unverifiedMessage,
} from '../../../utils/fundStatementLabels';
import type { StatementLayout } from '../../../utils/statementBlocks';
import { PeriodStatementBody, type RenderLine } from './PeriodStatementBody';

interface Props {
    state: FundAccountCardState;
    periodLabel: string;
    statement: PairPeriodStatement | null;
    layout: StatementLayout | null;
    onRetry: () => void;
    renderLine?: RenderLine;
}

export function FundAccountStatementBody({ state, periodLabel, statement, layout, onRetry, renderLine }: Props) {
    if (state === 'none') return <p className="text-sm text-mp-muted">{selectPrompt(periodLabel)}</p>;
    if (state === 'loading') return <LoadingSpinner message="Loading fund account statement" />;
    if (state === 'error') {
        return <QueryErrorAlert variant="error" message={unavailableMessage(periodLabel)} onRetry={onRetry} />;
    }
    if (state === 'unverified') {
        return <QueryErrorAlert variant="warning" message={unverifiedMessage(periodLabel)} onRetry={onRetry} />;
    }
    if (state === 'not_entitled') return <Alert variant="info" role="note">{NOT_ENTITLED_MESSAGE}</Alert>;
    if (!statement || !layout) return null;
    return (
        <PeriodStatementBody
            statement={statement}
            layout={layout}
            renderLine={renderLine}
        />
    );
}
